if (!customElements.get('text-hide-show')) {
  customElements.define(
    'text-hide-show',
    class TextHideShow extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-toggle]');
        this.textEl = this.querySelector('[data-text]');
        this.moreLabel = this.querySelector('[data-more]');
        this.lessLabel = this.querySelector('[data-less]');
        this.expanded = false;

        this.splitText();
        this.button?.addEventListener('click', () => this.toggle());
      }

      splitText() {
        const limit = parseInt(this.dataset.limit, 10) || 20;
        const fullText = this.textEl.textContent.trim();

        if (fullText.length <= limit) return;

        this.dataset.active = 'true';

        this.textEl.innerHTML = `<span data-full>${fullText}</span>`;
      }

      toggle() {
        this.expanded = !this.expanded;
        this.moreLabel?.toggleAttribute('data-hidden', this.expanded);
        this.lessLabel?.toggleAttribute('data-hidden', !this.expanded);

        if (this.expanded) {
          this.setAttribute('data-open', 'true');
        } else {
          this.removeAttribute('data-open');
        }
      }
    }
  );
}
